import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative inset-0 w-full h-full aspect-4/3 overflow-auto" }
const _hoisted_2 = ["src", "srcset"]
const _hoisted_3 = {
  key: 0,
  class: "absolute bottom-2 left-1/2 -translate-x-1/2 rounded-lg bg-brand-main/60 px-2 py-0.5 text-[8px] uppercase tracking-widest text-white z-10"
}

import { ref, watch, onMounted } from 'vue';
import { PanchImages } from '@/assets/ts/PanchImages';


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondImage',
  props: {
    diamond: {},
    alert: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const panchImageUrl = ref('');

const checkPanchImage = async () => {
  if (!props.diamond.image_url && props.diamond.certificate) {
    const panch = new PanchImages();
    panchImageUrl.value = (await panch.getStill(props.diamond.certificate)) as string;
  } else {
    panchImageUrl.value = '';
  }
};

onMounted(checkPanchImage);
watch(() => props.diamond, checkPanchImage, { deep: true });

const getLocalImage = (form: string, size: string) => {
  return (process.env.VUE_APP_HOST || "") + "/img/diamonds/cuts/cut_" + form.toLowerCase() + "@" + size + ".jpg";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: __props.diamond.image_url || panchImageUrl.value || getLocalImage(__props.diamond.form, '1x'),
      srcset: (!__props.diamond.image_url && !panchImageUrl.value) ? `${getLocalImage(__props.diamond.form, '1x')} 1x, ${getLocalImage(__props.diamond.form, '2x')} 2x` : undefined,
      alt: "Diamond",
      class: _normalizeClass(["w-full h-full object-cover", !__props.diamond.image_url && !panchImageUrl.value ? 'object-center' : 'object-bottom'])
    }, null, 10, _hoisted_2),
    (!__props.diamond.image_url && !panchImageUrl.value && __props.alert !== false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Beispielabbildung "))
      : _createCommentVNode("", true)
  ]))
}
}

})